import { useTestIntegrationMutation } from "api/TenantSlug/Integration/hooks";
import { BaseTestForm } from "components/Forms/BaseTestForm/BaseTestForm";
import { TestResult } from "components/Forms/BaseTestForm/TestResult";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { FormId } from "types/models";

import IntegrationData = App.Data.IntegrationData;

interface IntegrationTestFormProps {
    integration: IntegrationData;
}

export const IntegrationTestForm: FC<IntegrationTestFormProps> = ({ integration }) => {
    const { t } = usePaldockTranslation("forms.integration-test");
    const testMut = useTestIntegrationMutation();

    const resetTest = () => {
        testMut.reset();
    };

    return (
        <BaseTestForm
            formId={FormId.IntegrationTestForm}
            entityId={integration.id ?? ""}
            entityFilterKey="integration_id"
            loadingMessage={t("messages.processing")}
            errorMessage={t("messages.test_failed")}
            stepValidationMessage={t("messages.select_first_step")}
            testMutation={{
                mutate: ({ first_step_id, query_values, header_values, body_values }, options) => {
                    testMut.mutate(
                        {
                            integrationId: integration.id ?? "",
                            request: { first_step_id, query_values, header_values, body_values },
                        },
                        options
                    );
                },
                isPending: testMut.isPending,
                isSuccess: testMut.isSuccess,
                isError: testMut.isError,
                error: testMut.error ? { message: testMut.error.message } : undefined,
                reset: testMut.reset,
            }}
            onTestSuccess={(series) => <TestResult series={series} resetTest={resetTest} />}
        />
    );
};
